import { Link } from 'react-router-dom';
import { Brain, Bot, Eye, CheckCircle2, PlayCircle, Circle } from 'lucide-react';
import type { Lesson } from '../hooks/useApi';

interface LessonCardProps {
  lesson: Lesson;
  status?: 'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETED';
}

export default function LessonCard({ lesson, status = 'NOT_STARTED' }: LessonCardProps) {
  const modeConfig = {
    NO_TOOL: {
      icon: Brain,
      label: 'No AI Tools',
      color: 'text-amber-400 bg-amber-400/10 border-amber-400/30',
      description: 'Practice thinking independently'
    },
    OPEN_AI: {
      icon: Bot,
      label: 'AI Assisted',
      color: 'text-accent-blue bg-accent-blue/10 border-accent-blue/30',
      description: 'Use AI tools freely'
    },
    AUDIT: {
      icon: Eye,
      label: 'AI Audit',
      color: 'text-accent-purple bg-accent-purple/10 border-accent-purple/30',
      description: 'Critically evaluate AI outputs'
    }
  };

  const mode = modeConfig[lesson.mode];
  const ModeIcon = mode.icon;

  const StatusIcon = status === 'COMPLETED'
    ? CheckCircle2
    : status === 'IN_PROGRESS'
    ? PlayCircle
    : Circle;

  const statusColor = status === 'COMPLETED'
    ? 'text-accent-green'
    : status === 'IN_PROGRESS'
    ? 'text-accent-blue'
    : 'text-gray-600';

  return (
    <Link
      to={`/lessons/${lesson.id}`}
      className="group flex items-center gap-4 bg-background-secondary rounded-lg p-4 border border-gray-800 hover:border-gray-600 card-lift"
    >
      <StatusIcon className={`w-5 h-5 flex-shrink-0 ${statusColor}`} />

      <div className="flex-1 min-w-0">
        <h4 className="font-medium text-white group-hover:text-accent-blue transition-colors">
          {lesson.title}
        </h4>
        <div className={`inline-flex items-center gap-1.5 mt-1.5 px-2 py-0.5 rounded-full text-xs border ${mode.color}`}>
          <ModeIcon className="w-3 h-3" />
          {mode.label}
        </div>
      </div>
    </Link>
  );
}
